import React, { Component } from "react"
import createDOMPurify from "dompurify"

const DOMPurify = createDOMPurify(window)

class ShortTextWithReadMore extends Component {
    constructor(props) {
        super(props)
        this.state = {
            shouldShowMore:
                props.shouldShowMore !== undefined
                    ? props.shouldShowMore
                    : false
        }
        this.showMore = this.showMore.bind(this)
    }

    showMore() {
        this.setState({
            shouldShowMore: !this.state.shouldShowMore
        })
    }

    render() {
        const {
            shortenClass,
            allowHTML,
            dataCy,
            text,
            placeholder
        } = this.props
        let classList = this.props.classList || [],
            textElem
        const shouldShowMore =
            this.props.shouldShowMore !== undefined
                ? this.props.shouldShowMore
                : this.state.shouldShowMore
        if (!shouldShowMore) {
            classList = classList.concat([shortenClass || "shorten"])
        }

        if (allowHTML) {
            textElem = (
                <p
                    className={classList.join(" ")}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(text, {
                            FORBID_TAGS: ["img"]
                        })
                    }}
                    data-cy={dataCy}
                />
            )
        } else {
            textElem = (
                <p
                    style={{ whiteSpace: "pre-line" }}
                    className={classList.join(" ")}
                    data-cy={dataCy}
                >
                    {text}
                </p>
            )
        }

        return (
            <span>
                {text ? textElem : <p>{placeholder}</p>}
                {text && (
                    <p>
                        <a
                            onClick={this.showMore}
                            tabIndex={0}
                            className="read-more-button"
                        >
                            {!shouldShowMore ? "... Read more" : "Read less"}
                        </a>
                    </p>
                )}
            </span>
        )
    }
}

export default ShortTextWithReadMore
